import React from "react";
import { ArrowBackCircle, ArrowBackOutline, ArrowForwardOutline } from 'react-ionicons'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "@popperjs/core"
import { Modal } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import constantURI from "../URI"
import stylesMed from "./stylesMed"
import _post from "../Functions/Post";
import SearchFilterFunction from "../Functions/SearchFilter"
import Authenticate from "../Functions/MedRepAuthenticate"

export default class Reports extends React.Component {

    constructor() {
        super();
        this.state = {
            authenticate: false,
            fromDate: "",
            toDate: "",
            reportTypeInput: "",
            index: -1,
            showAlert: false,
            clients: [],
            reportTypes: [
                {
                    id: "0", name: "HCPs FeedBack",
                    Fields: [{ name: "Doctor" }, { name: "Speciality" }, { name: "Category" }, { name: "Zone" }, { name: "Date" }, { name: "Samples" },
                    { name: "Feedback" }, { name: "Objective" }]
                },
                {
                    id: "1", name: "Count Of Visited And NonVisited HCPs",
                    Fields: [{ name: "Visit" }, { name: "Type" }, { name: "Number" }]
                },
                {
                    id: "2", name: "List Of Visited HCPs",
                    Fields: [{ name: "Client Name" }, { name: "City" }, { name: "Specialty" }, { name: "Phone" }, { name: "LVD" }, { name: "Visited Num" }]
                },
                {
                    id: "3", name: "List Of NonVisited HCPs",
                    Fields: [{ name: "Client Name" }, { name: "City" }, { name: "Specialty" }, { name: "Phone" }, { name: "LVD" }, { name: "Unvisited Num" }]
                },
                {
                    id: "4", name: "HCPs Special Request",
                    Fields: [{ name: "Client Name" }, { name: "City" }, { name: "Specialty" }, { name: "Phone" }, { name: "LVD" }, { name: "Special Request" }]
                }],
            items: [],
            itemsFull: [],
            user: "",
            LVD: "",
            visited: 0,
            nonVisited: 0,
            getButton: false,
            loading: false,
            offsetNumber: 0,
            offsetFixed: 0,
            showRequiredAlert: false,
            alertUndefined: false,
            alertOffline: false,
            nodata : false,
            alertString: "",
            requiredFields: { fromDate: false, toDate: false, HCP: true, type: false },
            noData: true,
            clientsCopy: [],
            currentClientIndex: 0,
            doctors: false,
            pharmacies: false,
            clear: true,
            clientsLength: 0,
            token: "",
            selectedClient: 0

        }
    }

    async componentDidMount() {
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        const clients = localStorage.getItem('HCPs');
        const user = localStorage.getItem('User');
        const token = localStorage.getItem('Token');
        const isRep = localStorage.getItem('isRep');

        await this.setState({ clients: JSON.parse(clients), clientsCopy: JSON.parse(clients), user: JSON.parse(user), token: JSON.parse(token) });
        const clientsURL = constantURI() + "odooController/MedRepRead";
        if (!isRep) {
            const clientsBody = {
                jsonrpc: "2.0",
                params: {
                    method: "search_read",
                    model: "res.partner",
                    args: [],
                    kwargs: {
                        fields: ["name", "street", "phone", "potential", "state_id", "x_specialty_id", "clienttype"],
                    }
                },
                "token": this.state.token
            }
            if (this.state.authenticate) {
                await _post(clientsURL, clientsBody).then((response) => {
                    return response.json().then(async (data) => {
                        if (data.result !== undefined) {
                            this.setState({ clients: data.result, clientsCopy: data.result })
                            localStorage.setItem('HCPs', JSON.stringify(this.state.clients));
                        } else {
                            this.setState({ alertUndefined: true });
                        }
                    })
                })
            }
            else {
                const clients = localStorage.getItem('HCPs');
                this.setState({ clients: JSON.parse(clients), clientsCopy: JSON.parse(clients) });
            }
        }
        await this.setState({ clientsLength: this.state.clients.length })
        await this.setState({
            ...this.state.clients[this.state.clientsLength] = {},
            ...this.state.clients[this.state.clientsLength + 1] = {}
        })
        await this.setState({
            ...this.state.clients[this.state.clientsLength].name = "DOCTORS",
            ...this.state.clients[this.state.clientsLength + 1].name = "PHARMACIES"
        })
        await this.setState({ clientsCopy: this.state.clients });
    }

    onSelectClient = async (id) => {
        await this.setState({ clients: this.state.clientsCopy });
        if (id === -1)
            await this.setState({ index: id, getButton: false });
        else if (id === this.state.clientsLength || id === this.state.clientsLength + 1)
            await this.setState({ index: id, getButton: false });
        else {
            await this.state.clientsCopy.map(async (item, index) => {
                if (id === item.id)
                    await this.setState({ index: index, selectedClient: id, getButton: false });
            })
        }
        if ((this.state.index === "-1" || this.state.index === -1) && this.state.reportTypeInput === "0")
            await this.setState({ ...this.state.requiredFields.HCP = false });
        else
            await this.setState({ ...this.state.requiredFields.HCP = true });
        this.closeClientAlert();
    }

    onChangeReportType = async (e) => {
        await this.setState({ reportTypeInput: e.target.value, getButton: false });
        if (e.target.value === "")
            this.setState({ ...this.state.requiredFields.type = false })
        else if (e.target.value === "0" && this.state.requiredFields.HCP && (this.state.index === -1 || this.state.index === "-1"))
            this.setState({ ...this.state.requiredFields.type = true, ...this.state.requiredFields.HCP = false })
        else
            this.setState({ ...this.state.requiredFields.type = true, ...this.state.requiredFields.HCP = true })
    }

    onSelectFromDate = async (date) => {
        await this.setState({ fromDate: date, getButton: false })
        if (date === "")
            this.setState({ ...this.state.requiredFields.fromDate = false })
        else
            this.setState({ ...this.state.requiredFields.fromDate = true })
    }

    onSelectToDate = async (date) => {
        await this.setState({ toDate: date, getButton: false })
        if (date === "")
            this.setState({ ...this.state.requiredFields.toDate = false })
        else
            this.setState({ ...this.state.requiredFields.toDate = true })
    }

    closeClientAlert = () => {
        this.setState({ showAlert: false });
    }

    showClientAlert = () => {
        this.setState({ showAlert: true });
    }

    groupArrayOfObjects(list, key) {
        return list.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    };

    onGetReport = async () => {
        var toFill = false;
        var alertString = "";
        Object.keys(this.state.requiredFields).map(async (item, index) => {
            if (!this.state.requiredFields[item]) {
                toFill = true;
                alertString += item + ", ";
                await this.setState({ alertString: alertString });
            }
        })

        if (toFill === true) {
            this.setState({ showRequiredAlert: true });
        }
        else {
            this.setState({ loading: true, showRequiredAlert: false });
            this.getReport();
        }
    }

    itemsSplit = async () => {
        if (this.state.reportTypeInput === "2" || this.state.reportTypeInput === "3") {
            await this.setState({ LVD: new Date(Math.max(...this.state.items.map(e => new Date(e.start_datetime)))).toISOString().substring(0, 10) });
        }
        if (this.state.reportTypeInput === "1") {
            const groups = this.groupArrayOfObjects(this.state.items, 'x_status');
            Object.entries(groups).map(async (key, value) => {
                if (key[0] === "1") {
                    await this.setState({ visited: key[1].length });
                }
                else if (key[0] === "0") {
                    await this.setState({ nonVisited: key[1].length });
                }
                else if (key[0] === "4") {
                    var temp = this.state.nonVisited;
                    await this.setState({ nonVisited: temp + key[1].length });
                }
                else if (key[0] === "2") {
                    var temp = this.state.nonVisited;
                    await this.setState({ nonVisited: temp + key[1].length });
                }
            })
        }
    }

    getReport = async () => {
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        const reportTypeBodyFull = [{
            "jsonrpc": "2.0",
            "params": {
                "method": "search_read",
                "model": "calendar.event",
                "args": [],
                "kwargs": {
                    "fields": ["x_fbclient", "start_datetime", "x_event_line", "x_purpose", "id"],
                    "domain": [["start_datetime", ">=", this.state.fromDate.toISOString().substring(0, 10) + " 23:59:59"], ["start_datetime", "<=", this.state.toDate.toISOString().substring(0, 10) + " 23:59:59"], ["partner_ids", "=", this.state.selectedClient]]
                }
            },
            "token": this.state.token
        },
        {
            "jsonrpc": "2.0",
            "params": {
                "method": "search_read",
                "model": "calendar.event",
                "args": [],
                "kwargs": {
                    "fields": ["x_status", "start_datetime"],
                    "domain": [["start_datetime", ">=", this.state.fromDate.toISOString().substring(0, 10) + " 23:59:59"], ["start_datetime", "<=", this.state.toDate.toISOString().substring(0, 10) + " 23:59:59"], ["partner_ids", "=", this.state.selectedClient]]
                }
            },
            "token": this.state.token
        },
        {
            "jsonrpc": "2.0",
            "params": {
                "method": "search_read",
                "model": "calendar.event",
                "args": [],
                "kwargs": {
                    "fields": ["x_status", "start_datetime"],
                    "domain": [["start_datetime", ">=", this.state.fromDate.toISOString().substring(0, 10) + " 23:59:59"], ["start_datetime", "<=", this.state.toDate.toISOString().substring(0, 10) + " 23:59:59"], ["partner_ids", "=", this.state.selectedClient]]
                }
            },
            "token": this.state.token
        }, {
            "jsonrpc": "2.0",
            "params": {
                "method": "search_read",
                "model": "calendar.event",
                "args": [],
                "kwargs": {
                    "fields": ["x_status", "start_datetime"],
                    "domain": [["start_datetime", ">=", this.state.fromDate.toISOString().substring(0, 10) + " 23:59:59"], ["start_datetime", "<=", this.state.toDate.toISOString().substring(0, 10) + " 23:59:59"], ["partner_ids", "=", this.state.selectedClient]]
                }
            },
            "token": this.state.token
        }, {
            "jsonrpc": "2.0",
            "params": {
                "method": "search_read",
                "model": "calendar.event",
                "args": [],
                "kwargs": {
                    "fields": ["x_fbclient", "start_datetime", "x_event_line", "x_purpose", "id", "x_specialrequest_to_delivery"],
                    "domain": [["start_datetime", ">=", this.state.fromDate.toISOString().substring(0, 10) + " 23:59:59"], ["start_datetime", "<=", this.state.toDate.toISOString().substring(0, 10) + " 23:59:59"], ["partner_ids", "=", this.state.selectedClient]]
                }
            },
            "token": this.state.token
        }

        ]

        const reportTypeURL = constantURI() + "odooController/MedRepRead";

        if (this.state.authenticate) {
            this.setState({ alertOffline: false });
            this.setState({ nodata: false });
            this.setState({items :[]})
            await _post(reportTypeURL, reportTypeBodyFull[Number(this.state.reportTypeInput)]).then((response) => {
                return response.json().then(async (data) => {
                    if (data.result !== undefined) {
                        if (data.result.length !== 0) {
                            await this.setState({ items: data.result });

                            if (this.state.doctors || this.state.pharmacies) {
                                await this.selectionTypeFilter();
                            }
                            if (this.state.items.length !== 0)
                                await this.itemsSplit();
                        }
                        else {
                            this.setState({ nodata: true });
                        }
                        await this.setState({ getButton: true, loading: false });
                    } else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
        }
        else {
            this.setState({ items: undefined })
            this.setState({ alertOffline: true });
        }
    }

    onPrevious = async () => {
        await this.setState({ offsetFixed: this.state.offsetFixed - 1 });
        if (this.state.offsetFixed >= 0) {
            await this.setState({ offsetNumber: this.state.offsetFixed * 8, loading: true });
            this.getReport();
        }
        else {
            this.setState({ offsetFixed: this.state.offsetFixed + 1 })
        }
    }

    onNext = async () => {
        await this.setState({ offsetFixed: this.state.offsetFixed + 1 });
        await this.setState({ offsetNumber: this.state.offsetFixed * 8, loading: true });
        this.getReport();
    }

    onSearch = async (text) => {
        var values = await SearchFilterFunction(text, this.state.clients, this.state.clientsCopy, this.state.noData);
        this.setState({ clients: values.items, noData: values.noData })
    }

    onClickDoctors = async () => {
        this.onSelectClient(this.state.clientsLength)
        await this.setState({ doctors: true, pharmacies: false, clear: false });
        this.closeClientAlert();
    }

    onClickPharmacies = async () => {
        this.onSelectClient(this.state.clientsLength + 1)
        await this.setState({ doctors: false, pharmacies: true, clear: false });
        this.closeClientAlert();
    }

    onClickClear = async () => {
        await this.setState({ doctors: false, pharmacies: false, clear: true, clients: this.state.clientsCopy });
    }

    selectionTypeFilter = async () => {
        const temp = [];
        if (this.state.doctors && this.state.items.length != 0) {
            await this.state.items.forEach((item, index) => {
                this.state.clients.forEach((client, clientIndex) => {
                    if (item.partner_ids[0] === client.id && client.clienttype[0] === 1) {
                        temp.push(item);
                    }
                })
            })
            this.setState({ items: temp });
        }
        else if (this.state.pharmacies && this.state.items.length != 0) {
            await this.state.items.forEach((item, index) => {
                this.state.clients.forEach((client, clientIndex) => {
                    if (item.partner_ids[1] === client.id && client.clienttype[0] === 2) {
                        temp.push(item);
                    }
                })
            })
            this.setState({ items: temp });
        }
    }

    render() {
        console.log(this.state.clients);
        return (
            <div className="container-fluid vh-100"
                style={(this.state.items !== undefined && this.state.getButton) ? stylesMed.mainBackgroundColor : stylesMed.mainContainer}>
                {(!this.state.showRequiredAlert) ?
                    null :
                    <div className="col alert alert-danger">{this.state.alertString} are required fields that should be filled.</div>
                }

                {(!this.state.alertOffline) ?
                    null :
                    <div className="col alert alert-danger"> Please Connect To the internet.</div>
                }
                {(!this.state.nodata) ?
                null :
                <div className="col alert alert-danger"> No Data Found !!!</div>
                }
                {(!this.state.alertUndefined) ?
                    null :
                    <div className="col alert alert-danger">
                        <div className="row">
                            <h6 className="col-sm-8">There seems to be a problem.</h6>
                            <div className="col d-flex flex-row-reverse">
                                <div className={(this.state.disableSync) ? "btn disabled" : "btn"} style={stylesMed.wideButton} onClick={() => window.location.reload()}>
                                    Reload</div>
                            </div>
                        </div>
                    </div>
                }
                <div className="row pt-3">
                    <div className="col">
                        <ArrowBackCircle className="btn" onClick={() => this.props.history.push("./LandingPageRep")} color={'#00bfff'} height="50px" width="50px" />
                    </div>
                    <h5 className="col d-flex align-items-center justify-items-center" style={stylesMed.reportsTitle}>Reports</h5>
                    <div className="col"></div>
                </div>
                <div className="m-4 p-4" style={stylesMed.cardBackgroundColor}>
                    <div className="mt-3" style={stylesMed.reportInputWidth}>
                        <select className="col form-control text-center" id="sel1" value={this.state.reportTypeInput} onChange={this.onChangeReportType}
                            name="sellist1" style={stylesMed.reportType}>
                            <option value="">Report Type</option>
                            {this.state.reportTypes.map((item, index) => {
                                return (
                                    <option key={index} value={index}>{item.name}</option>
                                )
                            })
                            }
                        </select>
                    </div>
                    <div className="row mt-3">
                        <div className="col form-group">
                            <label>{(this.state.reportTypeInput === "0") ? "*HCP:" : "HCP:"}</label>
                            <input className="form-control"
                                defaultValue={(this.state.index === -1 || this.state.index === "-1") ? "" : this.state.clients[this.state.index].name}
                                onClick={this.showClientAlert} style={stylesMed.reportTypeInput} />
                        </div>
                        <div className="col mt-2 text-center">
                            <div className="btn" data-toggle="modal" data-target="#myModal" style={stylesMed.wideButton} onClick={this.onGetReport}>Get Report</div>
                        </div>
                    </div>
                    <Modal show={this.state.showAlert} onHide={this.closeClientAlert} animation={false}>
                        <Modal.Header>
                            <Modal.Title>Select Client</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div>
                                <input type="text" className="form-control" placeholder="Search Here" onChange={text => this.onSearch(text)} />
                                <div className="row mt-1">
                                    <div className="col btn" data-toggle="modal" data-target="#myModal" style={(this.state.doctors) ? stylesMed.wideButton : stylesMed.wideButtonUnclicked}
                                        onClick={() => this.onClickDoctors()}>Doctors</div>
                                    <div className="col btn" data-toggle="modal" data-target="#myModal" style={(this.state.pharmacies) ? stylesMed.wideButton : stylesMed.wideButtonUnclicked}
                                        onClick={() => this.onClickPharmacies()}>Pharmacies</div>
                                    <div className="col btn" data-toggle="modal" data-target="#myModal" style={(this.state.clear) ? stylesMed.wideButton : stylesMed.wideButtonUnclicked}
                                        onClick={() => this.onClickClear()}>Clear Filter</div>
                                </div>
                                <div>
                                    <div className="pt-3">
                                        <div className="btn" onClick={() => this.onSelectClient(-1)} >None</div>
                                    </div>
                                    {this.state.clients.map((item, index) => {
                                        return (
                                            <div className="pt-3" key={index}>
                                                <div className="btn" onClick={() => this.onSelectClient(item.id)} >{item.name}</div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div></Modal.Body>
                    </Modal>
                    <div className="row mt-3">
                        <div className="col-sm-3">
                            <p style={stylesMed.reportDate}>From Date*: </p>
                            <DatePicker selected={this.state.fromDate} onChange={(date) => this.onSelectFromDate(date)} />
                        </div>
                        <div className="col-sm-3">
                            <p style={stylesMed.reportDate}>To Date*: </p>
                            <DatePicker selected={this.state.toDate} onChange={(date) => this.onSelectToDate(date)} />
                        </div>
                    </div>
                </div>
                {this.state.reportTypes.map((item, index) => {
                    if (this.state.reportTypeInput === item.id && this.state.getButton) {
                        return (
                            <div className="m-4">
                                <div className="row" style={stylesMed.reportTableHeader} key={index}>
                                    {item.Fields.map((item2, index2) => {
                                        return (
                                            <h4 key={index2} className="col-sm-1 mt-2" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{item2.name}</h4>
                                        )
                                    })}
                                </div>
                                {/*<div className="row fixed-bottom" style={stylesMed.mainBackgroundColor}>*/}
                                {/*    <div className="col">*/}
                                {/*        <ArrowBackOutline className="btn" color={'#00bfff'} height="50px" width="50px" onClick={() => this.onPrevious()} />*/}
                                {/*        <h6>Previous Items</h6>*/}
                                {/*    </div>*/}
                                {/*    <div className="col" style={stylesMed.rightDirection}>*/}
                                {/*        <ArrowForwardOutline className="btn" color={'#00bfff'} height="50px" width="50px" onClick={() => this.onNext()} />*/}
                                {/*        <h6>Next Items</h6>*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                            </div>
                        )
                    }
                    else return null
                })
                }
                <div className="m-4">
                    {(this.state.items !== undefined && this.state.items.length !== 0 && this.state.getButton)
                        ? this.state.items.map((item, index, arr) => {
                            if (this.state.reportTypeInput === "0") {
                                return (
                                    <div className="row" style={stylesMed.reportTableRow} key={index}>
                                        <h5 className="col-sm-1 mt-2" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{this.state.clients[this.state.index].name}</h5>
                                        <h5 className="col-sm-1 mt-2" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{this.state.clients[this.state.index].x_specialty_id[1]}</h5>
                                        <h5 className="col-sm-1 mt-2" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{this.state.clients[this.state.index].potential[1]}</h5>
                                        <h5 className="col-sm-1 mt-2" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{this.state.clients[this.state.index].state_id[1]}</h5>
                                        <h5 className="col-sm-1 mt-2" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{item.start_datetime}</h5>
                                        <h5 className="col-sm-1 mt-2" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{item.x_event_line}</h5>
                                        <h5 className="col-sm-1 mt-2 " style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }} >{item.x_fbclient}</h5>
                                        <h5 className="col-sm-1 mt-2 text-justify" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }} >{item.x_purpose}</h5>
                                    </div>
                                )
                            }
                            if (this.state.reportTypeInput === "1" && index === arr.length - 1) {
                                return (
                                    <div key={index}>
                                        <div className="row" style={stylesMed.reportTableRow}>
                                            <h5 className="col-sm-1 mt-2">Non-Visited</h5>
                                            <h5 className="col-sm-1 mt-2">Doctor</h5>
                                            <h5 className="col-sm-1 mt-2">{this.state.nonVisited}</h5>
                                        </div>
                                        <div className="row" style={stylesMed.reportTableRow}>
                                            <h5 className="col-sm-1 mt-2">Visited</h5>
                                            <h5 className="col-sm-1 mt-2">Doctor</h5>
                                            <h5 className="col-sm-1 mt-2">{this.state.visited}</h5>
                                        </div>
                                    </div>
                                )
                            }
                            if (this.state.reportTypeInput === "2" && this.state.index !== -1 && index === arr.length - 1 && this.state.index !== this.state.clientsLength && this.state.index !== this.state.clientsLength + 1) {
                                return (
                                    <div className="row" style={stylesMed.reportTableRow} key={index}>
                                        <h5 className="col-sm-1 mt-2">{this.state.clients[this.state.index].name}</h5>
                                        <h5 className="col-sm-1 mt-2">{this.state.clients[this.state.index].state_id[1]}</h5>
                                        <h5 className="col-sm-1 mt-2">{this.state.clients[this.state.index].x_specialty_id[1]}</h5>
                                        <h5 className="col-sm-1 mt-2">{this.state.clients[this.state.index].phone}</h5>
                                        <h5 className="col-sm-1 mt-2">{this.state.LVD}</h5>
                                        <h5 className="col-sm-1 mt-2">{this.state.visited}</h5>
                                    </div>
                                )
                            }
                            else if (this.state.reportTypeInput === "2" && (this.state.index === -1 || this.state.index === this.state.clientsLength || this.state.index === this.state.clientsLength + 1)) {
                                return (
                                    this.state.clients.map((client, clientIndex) => {
                                        if (!this.state.pharmacies && item.partner_ids[0] === client.id) {
                                            return (
                                                <div className="row" style={stylesMed.reportTableRow} key={index}>
                                                    <h5 className="col-sm-1 mt-2">{this.state.clients[clientIndex].name}</h5>
                                                    <h5 className="col-sm-1 mt-2">{this.state.clients[clientIndex].state_id[1]}</h5>
                                                    <h5 className="col-sm-1 mt-2">{this.state.clients[clientIndex].x_specialty_id[1]}</h5>
                                                    <h5 className="col-sm-1 mt-2">{this.state.clients[clientIndex].phone}</h5>
                                                    <h5 className="col-sm-1 mt-2">{this.state.LVD}</h5>
                                                    <h5 className="col-sm-1 mt-2">{this.state.visited}</h5>
                                                </div>
                                            )
                                        }
                                        else if (this.state.pharmacies && item.partner_ids[1] === client.id) {
                                            return (
                                                <div className="row" style={stylesMed.reportTableRow} key={index}>
                                                    <h5 className="col-sm-1 mt-2">{this.state.clients[clientIndex].name}</h5>
                                                    <h5 className="col-sm-1 mt-2">{this.state.clients[clientIndex].state_id[1]}</h5>
                                                    <h5 className="col-sm-1 mt-2">{this.state.clients[clientIndex].x_specialty_id[1]}</h5>
                                                    <h5 className="col-sm-1 mt-2">{this.state.clients[clientIndex].phone}</h5>
                                                    <h5 className="col-sm-1 mt-2">{this.state.LVD}</h5>
                                                    <h5 className="col-sm-1 mt-2">{this.state.visited}</h5>
                                                </div>
                                            )
                                        }
                                    })
                                )
                            }
                            if (this.state.reportTypeInput === "3" && this.state.index !== -1 && index === arr.length - 1 && this.state.index !== this.state.clientsLength && this.state.index !== this.state.clientsLength + 1) {
                                return (
                                    <div className="row" style={stylesMed.reportTableRow} key={index}>
                                        <h5 className="col-sm-1 mt-2">{this.state.clients[this.state.index].name}</h5>
                                        <h5 className="col-sm-1 mt-2">{this.state.clients[this.state.index].state_id[1]}</h5>
                                        <h5 className="col-sm-1 mt-2">{this.state.clients[this.state.index].x_specialty_id[1]}</h5>
                                        <h5 className="col-sm-1 mt-2">{this.state.clients[this.state.index].phone}</h5>
                                        <h5 className="col-sm-1 mt-2">{this.state.LVD}</h5>
                                        <h5 className="col-sm-1 mt-2">{this.state.nonVisited}</h5>
                                    </div>
                                )
                            }
                            else if (this.state.reportTypeInput === "3" && (this.state.index === -1 || this.state.index === this.state.clientsLength || this.state.index === this.state.clientsLength + 1)) {
                                return (
                                    this.state.clients.map((client, clientIndex) => {
                                        if (!this.state.pharmacies && item.partner_ids[0] === client.id) {
                                            return (
                                                <div className="row" style={stylesMed.reportTableRow} key={index}>
                                                    <h5 className="col-sm-1 mt-2">{this.state.clients[clientIndex].name}</h5>
                                                    <h5 className="col-sm-1 mt-2">{this.state.clients[clientIndex].state_id[1]}</h5>
                                                    <h5 className="col-sm-1 mt-2">{this.state.clients[clientIndex].x_specialty_id[1]}</h5>
                                                    <h5 className="col-sm-1 mt-2">{this.state.clients[clientIndex].phone}</h5>
                                                    <h5 className="col-sm-1 mt-2">{this.state.LVD}</h5>
                                                    <h5 className="col-sm-1 mt-2">{this.state.nonVisited}</h5>
                                                </div>
                                            )
                                        }
                                        else if (this.state.pharmacies && item.partner_ids[1] === client.id) {
                                            return (
                                                <div className="row" style={stylesMed.reportTableRow} key={index}>
                                                    <h5 className="col-sm-1 mt-2">{this.state.clients[clientIndex].name}</h5>
                                                    <h5 className="col-sm-1 mt-2">{this.state.clients[clientIndex].state_id[1]}</h5>
                                                    <h5 className="col-sm-1 mt-2">{this.state.clients[clientIndex].x_specialty_id[1]}</h5>
                                                    <h5 className="col-sm-1 mt-2">{this.state.clients[clientIndex].phone}</h5>
                                                    <h5 className="col-sm-1 mt-2">{this.state.LVD}</h5>
                                                    <h5 className="col-sm-1 mt-2">{this.state.nonVisited}</h5>
                                                </div>
                                            )
                                        }
                                    })
                                )
                            }
                            if (this.state.reportTypeInput === "4" && this.state.index !== -1 && index === arr.length - 1 && this.state.index !== this.state.clientsLength && this.state.index !== this.state.clientsLength + 1) {
                                return (
                                    <div className="row" style={stylesMed.reportTableRow} key={index}>
                                        <h5 className="col-sm-1 mt-2">{this.state.clients[this.state.index].name}</h5>
                                        <h5 className="col-sm-1 mt-2">{this.state.clients[this.state.index].state_id[1]}</h5>
                                        <h5 className="col-sm-1 mt-2">{this.state.clients[this.state.index].x_specialty_id[1]}</h5>
                                        <h5 className="col-sm-1 mt-2">{this.state.clients[this.state.index].phone}</h5>
                                        <h5 className="col-sm-1 mt-2">{this.state.LVD}</h5>
                                        <h5 className="col-sm-1 mt-2">{item.x_specialrequest_to_delivery}</h5>
                                    </div>
                                )
                            }
                            else if (this.state.reportTypeInput === "4" && (this.state.index === -1 || this.state.index === this.state.clientsLength || this.state.index === this.state.clientsLength + 1)) {
                                return (
                                    this.state.clients.map((client, clientIndex) => {
                                        if (!this.state.pharmacies && item.partner_ids[0] === client.id) {
                                            return (
                                                <div className="row" style={stylesMed.reportTableRow} key={index}>
                                                    <h5 className="col-sm-1 mt-2">{this.state.clients[clientIndex].name}</h5>
                                                    <h5 className="col-sm-1 mt-2">{this.state.clients[clientIndex].state_id[1]}</h5>
                                                    <h5 className="col-sm-1 mt-2">{this.state.clients[clientIndex].x_specialty_id[1]}</h5>
                                                    <h5 className="col-sm-1 mt-2">{this.state.clients[clientIndex].phone}</h5>
                                                    <h5 className="col-sm-1 mt-2">{this.state.LVD}</h5>
                                                    <h5 className="col-sm-1 mt-2">{item.x_specialrequest_to_delivery}</h5>
                                                </div>
                                            )
                                        }
                                        else if (this.state.pharmacies && item.partner_ids[1] === client.id) {
                                            return (
                                                <div className="row" style={stylesMed.reportTableRow} key={index}>
                                                    <h5 className="col-sm-1 mt-2">{this.state.clients[clientIndex].name}</h5>
                                                    <h5 className="col-sm-1 mt-2">{this.state.clients[clientIndex].state_id[1]}</h5>
                                                    <h5 className="col-sm-1 mt-2">{this.state.clients[clientIndex].x_specialty_id[1]}</h5>
                                                    <h5 className="col-sm-1 mt-2">{this.state.clients[clientIndex].phone}</h5>
                                                    <h5 className="col-sm-1 mt-2">{this.state.LVD}</h5>
                                                    <h5 className="col-sm-1 mt-2">{item.x_specialrequest_to_delivery}</h5>
                                                </div>
                                            )
                                        }
                                    })
                                )
                            }
                        })
                        : (this.state.items === undefined) ? null :
                            (this.state.loading) ?
                                <div className="pt-3 text-center">
                                    <div className="spinner-border" style={stylesMed.spinner}></div>
                                </div> : null
                    }
                </div>
            </div>
        );
    }
}
